import "./Destinations.module.css";
import Navigation from "@/reusable_sections/Header";
import FeaturedJourneys from "./sections/FeaturedJourneys";
import PathToSuccess from "./sections/PathToSuccess";
import BioCertifiedLabStandards from "./sections/BioCertifiedLabStandards";
import Footer from "@/reusable_sections/Footer";
export default function DestinationsPage() {
  return <div>
      <Navigation />
      <FeaturedJourneys />
      <PathToSuccess />
      <BioCertifiedLabStandards />
      <Footer />
    </div>;
}